import React, { useRef } from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas-pro';
import { FaDownload, FaArrowLeft } from 'react-icons/fa';
import './ExperienceLetter.css'; // We will create this next

const ExperienceLetter = ({ record, onBack }) => {
  const letterRef = useRef();

  // Debug: Log the record to see what data we're getting
  console.log("Experience Letter - Record data:", record);

  const handleDownload = () => {
    const input = letterRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Experience_Letter_${record.employeeName}.pdf`);
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Present";
    return new Date(dateString).toLocaleDateString('en-IN', {
      timeZone: 'Asia/Kolkata', day: 'numeric', month: 'long', year: 'numeric'
    });
  };

  // Safeguard: If record is null or missing critical fields
  if (!record) {
    return (
      <div className="experience-letter-view">
        <div className="letter-actions">
          <button onClick={onBack} className="action-btn-secondary"><FaArrowLeft /> Back</button>
        </div>
        <div style={{padding: '40px', textAlign: 'center'}}>
          <p>⚠️ No experience record data available.</p>
        </div>
      </div>
    );
  }

 // Build tenure description paragraph
const getTenureText = () => {
  const position = record.position || 'Employee';
  const name = record.employeeName || 'The employee';

  if (record.department) {
    return `During their service with the organization, ${name} successfully served as ${position} in the ${record.department} department.`;
  }

  return `During their service with the organization, ${name} successfully served as ${position}.`;
};

  return (
    <div className="experience-letter-view">
      <div className="letter-actions">
        <button onClick={onBack} className="action-btn-secondary" data-tooltip="Back to Editor"><FaArrowLeft /> Back to Editor</button>
        <button onClick={handleDownload} className="action-btn-primary" data-tooltip="Download as PDF"><FaDownload /> Download as PDF</button>
      </div>

      <div ref={letterRef} className="letter-paper">
        <div className="letter-header">
            <div className="letter-logo">
              <img src="/PrepXPathshala_logo2.jpg" alt="Company Logo" />
            </div>
            <div className="letter-company-info">
              <h1>PRREPX PATHSHALA PRIVATE LIMITED</h1>
              <p style={{fontSize: '0.85em', marginTop: '2px'}}>ET 15/302 EWS LIG, DLF GARDEN, Purseni, Mohanlalganj, Lucknow- 226301 Uttar Pradesh</p>
              <p style={{fontSize: '0.9em', marginTop: '4px'}}>CIN: U85306UP2025PTC238181 | Website: https://www.prrepxpathshala.live</p>
            </div>
            <hr />
        </div>
        <div className="letter-body">
            <p className="subject">
            <strong>Subject: Experience Certificate & Relieving Letter</strong>
            </p>

            <p>To Whom It May Concern,</p>
            <p>
              This is to certify that <strong>{record.employeeName || 'N/A'}</strong> (Employee ID: <strong>{record.employeeId || 'N/A'}</strong>) was employed with <strong>PRREPX PATHSHALA PRIVATE LIMITED</strong> as <strong>{record.position || '[Designation]'}</strong> from <strong>{formatDate(record.joiningDate)}</strong> to <strong>{formatDate(record.leavingDate)}</strong>.
            </p>
            <p>{getTenureText()}</p>
            <p>
              This letter confirms that <strong>{record.employeeName || 'N/A'}</strong> has been officially relieved of all duties and responsibilities with the company, effective from the close of business hours on <strong>{formatDate(record.leavingDate)}</strong>, following the completion of all exit formalities.
            </p>
            <p>
              During their tenure with us, we found them to be professional, dedicated, and sincere in their conduct. We appreciate their contributions to the organization and wish them every success in their future endeavors.
            </p>
            <p>Sincerely,</p>
            
            <div className="signature-area">
              <div className="signature-details">
                <img className="authorized-signature" src="/sign.png" alt="Authorized signatory signature" />
                <p><strong>Authorized Signatory</strong></p>
                <p>PRREPX PATHSHALA PRIVATE LIMITED</p>
              </div>
              <img className="company-stamp" src="/stamp.png" alt="Company stamp" />
            </div>

            
        </div>
        <div className="exp-footer">
          <p>This is a computer-generated experience certificate and does not require a signature.</p>
        </div>
      </div>
    </div>
  );
};

export default ExperienceLetter;